import React from "react";
import { Link } from "react-router-dom";
import { useLang, pick } from "../context/LanguageContext";
import { t } from "../data/translations";
import { resolveImg } from "../lib/api";

export const Footer = ({ settings }) => {
  const { lang } = useLang();
  return (
    <footer className="border-t border-brand-line bg-brand-surface" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="flex items-center gap-4">
            <span className="inline-flex items-center rounded-xl bg-white px-3 py-2 shrink-0">
              <img src={resolveImg(settings?.logo_url)} alt="" className="h-12 w-auto max-w-[160px] object-contain" />
            </span>
            <div>
              <p className="font-display text-2xl leading-none">{settings?.business_name}</p>
              <p className="text-sm text-brand-muted mt-1">{settings?.address}</p>
            </div>
          </div>
          <div className="flex items-center gap-8 text-sm">
            <a href="#menu" className="text-brand-muted hover:text-brand-text transition-colors">{pick(t.nav.menu, lang)}</a>
            <a href="#story" className="text-brand-muted hover:text-brand-text transition-colors">{pick(t.nav.story, lang)}</a>
            <a href="#visit" className="text-brand-muted hover:text-brand-text transition-colors">{pick(t.nav.visit, lang)}</a>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-brand-line/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-muted/70">
          <p>© {new Date().getFullYear()} {settings?.business_name}. {pick(t.footer.rights, lang)}</p>
          <Link to="/admin" className="hover:text-brand-gold transition-colors" data-testid="footer-admin-link">{pick(t.footer.admin, lang)}</Link>
        </div>
      </div>
    </footer>
  );
};
